import { Checkbox, Tooltip } from 'bold-ui'
import { ReceitaMedicamentoSdcDto } from 'graphql/types.generated'
import React from 'react'

interface PrescricaoSdcProps {
  prescricao: ReceitaMedicamentoSdcDto
  handleTogglePrescricao: (prescricao: ReceitaMedicamentoSdcDto) => void
  dataTestId?: string
}
export function PrescricaoSdcCheckbox(props: Readonly<PrescricaoSdcProps>) {
  const { prescricao, handleTogglePrescricao, dataTestId } = props
  const { medicamentoCatmat, motivoRestricaoPrescricao, prescrever, unidadeMedidaDose } = prescricao
  const { principioAtivo, concentracao } = medicamentoCatmat.medicamento

  return (
    <Tooltip text={motivoRestricaoPrescricao}>
      <span data-testid={dataTestId}>
        <Checkbox
          label={`${principioAtivo} ${concentracao.replace('ml', 'mL')} ${
            unidadeMedidaDose.nomePlural && `em ${unidadeMedidaDose.nomePlural.toLowerCase()}`
          }`}
          disabled={!prescrever}
          onChange={() => handleTogglePrescricao(prescricao)}
        />
      </span>
    </Tooltip>
  )
}
